export default function initializeImageSlider() {
  document.querySelectorAll('.image-slider:not(.image-slider--disabled)').forEach(async function (slider) {
    // Dynamiczny import biblioteki Swiper
    const { default: Swiper } = await import('swiper/bundle');

    const swiper = new Swiper(slider, {
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          opacity: 0,
          scale: 1.1,
        },
        next: {
          shadow: true,
          opacity: 0,
          scale: 1.1,
        },
      },
      autoHeight: true,
      speed: 5000,
      loop: true,
      autoplay: {
        delay: 300,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".slider__pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
      }
    });

    // Znajdź przycisk kontrolny
    const controlButton = slider.querySelector('.swiper-controls__button');
    const pauseIcon = controlButton.querySelector('.swiper-controls__button-icon--pause');
    const startIcon = controlButton.querySelector('.swiper-controls__button-icon--start');

    controlButton.addEventListener('click', () => {
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
        controlButton.setAttribute('aria-label', startIcon.title.trim());
        pauseIcon.classList.add('d-none');
        startIcon.classList.remove('d-none');
      } else {
        swiper.autoplay.start();
        controlButton.setAttribute('aria-label', pauseIcon.title.trim());
        startIcon.classList.add('d-none');
        pauseIcon.classList.remove('d-none');
      }
    });
  });
}
